<template>
  <b-table :items="items" :fields="fields"></b-table>
</template>

<script>
export default {
  name: "submitfrom",

  data() {
    return {
      fields: ['title', 'sessions'],
      items: []
    };
  },
  mounted() {},
  methods: {
    getData(array) {
      let that = this;
      if (array.mostSubmittedForm && array.mostSubmittedForm.buckets && array.mostSubmittedForm.buckets.length > 0) {
        array.mostSubmittedForm.buckets.map(r => {
          let form = {};
          form.title = r.key;
          form.sessions = r.doc_count;
          that.items.push(form);
        });
      }
    },
  }
};
</script>
